import { FunctionComponent, useState, useEffect, useRef, useTransition } from 'react';
import { Spinner, Dropdown, DropdownOption, InlineMessage } from "@volvo/vcdk-react";
import { useGetCompaniesQuery } from '../../../store/InvoiceApiSlice';
import { Company } from '../../../Types';

export const EntityDropdown: FunctionComponent = () => {

    const {data: companyList = [], isLoading, isSuccess, isError, error} = useGetCompaniesQuery({});
    

    return (
        <div>
            { isLoading ? <Spinner /> : <Dropdown label='Invoicing entity' size='small'>
                {companyList.map((company: Company) => (
                    <DropdownOption key={company.companyID} value={company.companyID.toString()}>
                        {company.name}
                    </DropdownOption>
                ))}
            </Dropdown>}
        </div>
    );
}